import { PaginationStateProps } from '../types';
import {
  MollyWhitelabelCustomer,
  MollyWhitelabelCustomerKYCDocument,
  MollyWhitelabelCustomerLiveInfo,
  MollyWhitelabelCustomerNetTransfers,
  MollyWhitelabelCustomerPL,
  MollyWhitelabelCustomerSummary,
} from './actions';

// #region MollyWhitelabelCustomer
export interface MollyWhitelabelCustomerState {
  pending: boolean;
  customer: null | MollyWhitelabelCustomer;
  error?: string;
}

export const defaultMollyWhitelabelCustomerState = {
  pending: false,
  customer: null,
  error: null,
};

export interface MollyWhitelabelCustomerSummariesState
  extends PaginationStateProps {
  pending: boolean;
  customers: null | MollyWhitelabelCustomerSummary[];
  error?: string;
}

export const defaultMollyWhitelabelCustomerSummariesState = {
  pending: false,
  customers: null,
  error: null,
};
// endregion

// #region MollyWhitelabelCustomerKYCDocument
export interface MollyWhitelabelCustomerKYCDocumentsState {
  pending: boolean;
  documents: null | MollyWhitelabelCustomerKYCDocument[];
  error?: string;
}

export const defaultMollyWhitelabelCustomerKYCDocumentsState = {
  pending: false,
  documents: null,
  error: null,
};

export interface MollyWhitelabelKYCDocumentsState extends PaginationStateProps {
  pending: boolean;
  documents: null | MollyWhitelabelCustomerKYCDocument[];
  error?: string;
}

export const defaultMollyWhitelabelKYCDocumentsState = {
  pending: false,
  documents: null,
  error: null,
};
//endregion

// #region MollyWhitelabelCustomerLiveInfo
export interface MollyWhitelabelCustomerLiveInfoState {
  pending: boolean;
  liveInfo: null | MollyWhitelabelCustomerLiveInfo;
  error?: string;
}

export const defaultMollyWhitelabelCustomerLiveInfoState = {
  pending: false,
  liveInfo: null,
  error: null,
};
//endregion

// #region MollyWhitelabelCustomerPL
export interface MollyWhitelabelCustomerPLState {
  pending: boolean;
  pl: null | MollyWhitelabelCustomerPL;
  error?: string;
}

export const defaultMollyWhitelabelCustomerPLState = {
  pending: false,
  pl: null,
  error: null,
};
//endregion

// #region MollyWhitelabelCustomerNetTransfers
export interface MollyWhitelabelCustomerNetTransfersState {
  pending: boolean;
  netTransfers: null | MollyWhitelabelCustomerNetTransfers;
  error?: string;
}

export const defaultMollyWhitelabelCustomerNetTransfersState = {
  pending: false,
  netTransfers: null,
  error: null,
};
//endregion
